<app-element-loader
  [loadingStatus]="loadingStatus"
  [loadingMessage]="loadingMessage">
</app-element-loader>

<div class="detail-recap">

  <div class="detail-recap__header" *ngIf="selectedSolution">

    <!-- Prezzo ed ospiti -->
    <div *ngIf="selectedSolution?.totalPrice" class="detail-recap__occupancy">
      <!-- prezzo totale se disponibile-->
      <span class="detail-recap__price"><span>da</span> &euro;{{selectedSolution.totalPrice | number: '1.0-0'}}</span>
      <span class="detail-recap__guests">per {{formattedGuestsString}}</span>
    </div>

    <div *ngIf="!selectedSolution?.totalPrice && selectedSolution.price" class="detail-recap__occupancy">
      <!-- prezzo a persona (se il totale non è disponibile)-->
      <span class="detail-recap__price"><span>da</span> &euro;{{selectedSolution.price | number: '1.0-0'}}</span>
      <span class="detail-recap__guests">per persona</span>
    </div>
    <!-- Modifica passeggeri per WTG solamente -->
    <a *ngIf="brand?.networkId === wtgNetworkId"
       #editGuestsRef
       (click)="openEngineGuestsModal()"
       class="detail-recap__change-guests">Modifica passeggeri</a>
    <!-- Vedi Opzioni (solo desktop) -->
    <button class="detail-recap__see-options btn" *ngIf="selectedSolution?.journey" (click)="scrollToOptions()">
      Vedi opzioni
    </button>
    <!-- Stringa di Recap (solo mobile) -->
    <div class="detail-recap__recap-string">
      <span *ngIf="selectedSolution?.journey"> da {{selectedSolution?.journey?.outward?.departureAirport.name}} /
      </span>{{selectedSolution.dateFrom | formatDate : 'shortDayMonth'}} - {{selectedSolution.dateTo | formatDate :
      'shortDayMonth'}}
    </div>
  </div>

  <div class="detail-recap__body" *ngIf="selectedSolution">
    <!-- Destinazione -->
    <div class="detail-recap__row detail-recap__destination">
      <div class="detail-recap__icon">
        <i class="icon-pin"></i>
      </div>
      <div class="detail-recap__text">
        {{destinationName}}
      </div>
    </div>
    <!-- Durata della vacanza -->
    <div class="detail-recap__row detail-recap__duration">
      <div class="detail-recap__icon">
        <i class="icon-clock-simple"></i>
      </div>
      <div class="detail-recap__text">
        {{selectedSolution.nights}} notti
      </div>
    </div>
    <!-- Data di partenza e arrivo -->
    <div class="detail-recap__row detail-recap__check-in"
         *ngIf="selectedSolution?.journey && (selectedSolution?.journey?.outward?.departureDate || selectedSolution?.journey?.return?.departureDate)">
      <div class="detail-recap__icon">
        <i class="icon-calendar"></i>
      </div>
      <div class="detail-recap__text">
        <span><strong>Dal</strong> {{selectedSolution?.journey?.outward?.departureDate | formatDate : 'extendedDayMonthYear'}}</span>
        <br>
        <span><strong>Al</strong> {{selectedSolution?.journey?.return?.departureDate | formatDate : 'extendedDayMonthYear'}}</span>
      </div>
    </div>
    <!-- Volo di Andata -->
    <div class="detail-recap__row detail-recap__flight detail-recap__flight--outward"
         *ngIf="selectedSolution?.journey?.outward?.departureAirport">
      <div class="detail-recap__icon">
        <i class="icon-take-off"></i>
      </div>
      <div class="detail-recap__text">
        <span><strong>{{selectedSolution?.journey?.outward?.departureAirport.name}}
          ({{selectedSolution?.journey?.outward?.departureAirport.code}}) </strong></span>
        <span> {{selectedSolution?.journey?.outward?.departureDate | formatDate : 'extendedDateDayMonthYear'}}</span>
        <span
          *ngIf="selectedSolution?.journey?.outward?.departureHour"> ({{selectedSolution?.journey?.outward?.departureHour}}
          )</span>
      </div>
    </div>
    <!-- Scalo (volo) -->
    <div class="detail-recap__row detail-recap__flight detail-recap__flight--outward"
         *ngIf="selectedSolution?.journey?.outward?.stopOver">
      <div class="detail-recap__icon">
        <i class="icon-arrows"></i>
      </div>
      <div class="detail-recap__text">
        <span>Scalo: <strong>{{selectedSolution?.journey?.outward?.stopOver?.name}}
          <span
            *ngIf="((selectedSolution?.journey?.outward?.stopOver?.id | getDataFromMapping:'airportId') | async)?.Code">
            ({{((selectedSolution?.journey?.outward?.stopOver?.id | getDataFromMapping:'airportId') | async)?.Code}})
          </span>
        </strong>
        <br>
        <span
          *ngIf="selectedSolution?.journey?.outward?.stopOverDuration">Durata: {{selectedSolution?.journey?.outward?.stopOverDuration}}</span></span>
      </div>
    </div>
    <!-- Volo di Ritorno -->
    <div class="detail-recap__row detail-recap__flight detail-recap__flight--return"
         *ngIf="selectedSolution?.journey?.outward?.arrivalAirport">
      <div class="detail-recap__icon">
        <i class="icon-landing"></i>
      </div>
      <div class="detail-recap__text">
        <span><strong>{{selectedSolution?.journey?.outward?.arrivalAirport.name}}
          ({{selectedSolution?.journey?.outward?.arrivalAirport.code}}) </strong></span>
        <span>{{selectedSolution?.journey?.outward?.arrivalDate | formatDate : 'extendedDateDayMonthYear'}}</span>
        <span *ngIf="selectedSolution?.journey?.outward?.arrivalHour">
          ({{selectedSolution?.journey?.outward?.arrivalHour}})</span>
      </div>
    </div>
    <!-- Check-In -->
    <div class="detail-recap__row detail-recap__check-in" *ngIf="!selectedSolution?.journey">
      <div class="detail-recap__icon">
        <i class="icon-arrow-thick-right"></i>
      </div>
      <div class="detail-recap__text">
        <span><strong>Check in</strong>: {{selectedSolution.dateFrom | formatDate : 'extendedDateDayMonthYear'}}</span>
      </div>
    </div>
    <!-- Check-Out -->
    <div class="detail-recap__row detail-recap__check-out" *ngIf="!selectedSolution?.journey">
      <div class="detail-recap__icon">
        <i class="icon-arrow-thick-left"></i>
      </div>
      <div class="detail-recap__text">
        <span><strong>Check out</strong>: {{selectedSolution.dateTo | formatDate : 'extendedDateDayMonthYear'}}</span>
      </div>
    </div>
  </div>
  
  <div class="detail-recap__body" *ngIf="!selectedSolution && !noAvailability">
    <ng-container>
      <p *ngIf="this.holidayDetails.searchSolution.dateFrom && this.holidayDetails.solutions.length > 0">
        Abbiamo trovato <span class="u-text--link"
                              (click)="this.onClickOnChooseSolution()">{{this.holidayDetails.solutions.length}}
        soluzion{{ this.holidayDetails.solutions.length === 1 ? 'e' : 'i'}}</span>
        disponibil{{ this.holidayDetails.solutions.length === 1 ? 'e' : 'i'}} per
        il {{this.holidayDetails.searchSolution.dateFrom | date }}.
      </p>
      <p *ngIf="this.holidayDetails.searchSolution.dateFrom && !this.holidayDetails.solutions.length">
        Nessuna soluzione disponibile il {{this.holidayDetails.searchSolution.dateFrom | date }} per {{this.formattedGuestsString}}.
        Prova ad eseguire una nuova ricerca.
      </p>
    </ng-container>
  </div>

  <div class="detail-recap__body" *ngIf="noAvailability">
    <ng-container>
      <h6>Attenzione!</h6>
      <p>
        Non è disponibile più alcuna soluzione per la vacanza cercata.
      </p>
    </ng-container>
  </div>

  <!-- Pulsante Richiedi Informazioni -->
  <div class="detail-recap__accordion" *ngIf="isLanding">
    <app-info-request [packetInfo]="holidayDetails.title" [packetUrl]="detailUrl | async"
                      [isLanding]="isLanding"></app-info-request>
  </div>

  <!-- Pulsante Condividi -->
  <div class="detail-recap__share" *ngIf="!noAvailability">
    <a target="_blank"
       class="detail-recap__share__button detail-recap__cta__button btn btn--blue-outline text-lowercase"
       href="https://www.facebook.com/sharer/sharer.php?u={{location}};src=sdkpreparse">
      <i class="icon-facebook detail-recap__share__icon"></i>
      <span class="detail-recap__share__text">Condividi</span>
    </a>
  </div>

  
  <div class="detail-recap__footer" *ngIf="!this.selectedSolution && !noAvailability">
    <div class="detail-recap__row detail-recap__cta__wrapper">

      <ng-container *ngIf="!this.holidayDetails.searchSolution.dateFrom">
        <a class="detail-recap__cta__button btn btn--brand-color-03" href="javascript:void(null)"
           >
          Scegli Data
        </a>
      </ng-container>

      <ng-container *ngIf="this.holidayDetails.searchSolution.dateFrom">
        <a class="detail-recap__cta__button btn btn--brand-color-03"
           
           
           (click)="this.onClickOnChooseSolution()">
          Scegli Partenza
        </a>
      </ng-container>

    </div>
  </div>
  
  <div class="detail-recap__footer" *ngIf="!noAvailability">
    <div class="detail-recap__row detail-recap__cta__wrapper" [ngClass]="!selectedSolution ? 'disabled' : ''" *ngIf="!isLanding">
      <a class="detail-recap__cta__button btn btn--brand-color-03" dynamicNavigation
         [href]="bookingUrl">
        Prosegui
      </a>
    </div>
  </div>
</div>
